export const administrationRouter = [
    {
        path: '/addcomponents',
        name: 'addcomponents',
        component: () => import('../views/administration/AddComponents.vue')
    }
];
